import { motion } from "framer-motion";
import Collage from "@/components/site/Collage";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-28 md:pt-32 lg:pt-36 pb-10 md:pb-16 px-4 md:px-8 lg:px-12 overflow-hidden"
    >
      {/* Top meta row */}
      <div className="flex items-center justify-between mb-10 md:mb-14 gap-4 flex-wrap">
        <div className="section-label text-[#4A4A4A] flex items-center gap-3">
          <span className="blink text-[#D83127]">●</span> CHICAGO / LOS ANGELES
          <span className="hidden sm:inline text-[#4A4A4A]/60">·</span>
          <span className="hidden sm:inline hard-border px-2 py-1 font-mono-s text-[10px] tracking-[0.25em] uppercase bg-[#F2EFE9]">
            Currently booking Q2 2026
          </span>
        </div>
        <div className="hidden md:block font-mono-s text-xs tracking-[0.2em] uppercase text-[#4A4A4A]">
          Vol. 010 — Brand &amp; Culture
        </div>
      </div>

      <div className="grid grid-cols-12 gap-4 md:gap-6 items-start">
        {/* Left column: eyebrow + image */}
        <div className="col-span-12 md:col-span-4 lg:col-span-4 order-2 md:order-1 flex flex-col gap-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.35 }}
            className="hard-border bg-[#E8E4DB] p-5 max-w-sm"
          >
            <div className="font-mono-s text-[10px] tracking-[0.3em] uppercase text-[#4A4A4A] mb-2">
              Dossier / 001
            </div>
            <p className="font-cormorant text-xl md:text-2xl leading-snug italic">
              “I connect brands to the audiences that matter and build the authentic culture that
              turns that connection into sustained revenue growth.”
            </p>
            <div className="mt-4 font-mono-s text-[10px] tracking-[0.25em] uppercase">
              — JPK, Senior Brand &amp; Marketing Lead
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.55 }}
          >
            <Collage />
          </motion.div>
        </div>

        {/* Right column: giant headline */}
        <div className="col-span-12 md:col-span-8 lg:col-span-8 order-1 md:order-2">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.15 }}
            className="font-anton uppercase leading-[0.86] tracking-[-0.005em]"
          >
            <div className="text-[14vw] md:text-[11vw] lg:text-[10.5vw] flex items-baseline flex-wrap gap-x-6">
              <span>Built on</span>
              <span className="font-cormorant italic lowercase text-[#D83127] font-semibold">connection,</span>
            </div>
            <div className="text-[14vw] md:text-[11vw] lg:text-[10.5vw] flex items-baseline flex-wrap gap-x-6">
              <span>grown through</span>
              <span className="font-cormorant italic lowercase text-[#2E4F36] font-semibold">culture,</span>
            </div>
            <div className="text-[14vw] md:text-[11vw] lg:text-[10.5vw] flex items-baseline flex-wrap gap-x-6">
              <span>paid in</span>
              <span className="underline decoration-[6px] underline-offset-[14px] decoration-[#2E4F36]">revenue.</span>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="mt-8 md:mt-10 flex flex-col md:flex-row md:items-end gap-6 md:gap-10"
          >
            <p className="font-work text-lg md:text-xl max-w-xl leading-relaxed">
              I&apos;m <strong>John &quot;JP&quot; Kuster</strong> — a senior brand and marketing
              leader. Over the last decade I&apos;ve built the #1 cannabis brand in the country,
              driven 550%+ marketing-attributed revenue growth for an art-tech studio, and led the
              modernization of a century-old financial institution. Strategy, creative direction,
              and real human connection — that&apos;s the work.
            </p>

            <div className="flex gap-3 items-center md:items-end">
              <a href="#contact" className="btn-offset" data-testid="hero-cta-contact">
                Start a Project →
              </a>
              <a href="#work" className="btn-offset inverse" data-testid="hero-cta-work">
                See the Work
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
